// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Ko-z","slideIn":"Lo-z"};